import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DistributionGroup } from 'src/app/models/distribution-group.model';
import { RecipientsReplyComponent } from "../../../questionnaires/features/table-grid/features/questionnaires-list-page/components/recipients-reply/recipients-reply.component";
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { DistributionGroupMenuItemComponent } from "../distribution-group-menu-item/distribution-group-menu-item.component";
import { Recipient, Recipients } from 'src/app/models/recipients.model';
import { DistributionGroupSquareComponent } from 'src/app/features/questionnaires/features/table-grid/features/questionnaire-data/components/distribution-group-square/distribution-group-square';
import { MatDialog } from '@angular/material/dialog';
import { CreateDistributionGroupComponent } from 'src/app/features/users/components/create-distribution-group/create-distribution-group';
import { DistributionGroupStore } from '../../store/distribution-group-store';
import { DistributionRecipientsComponent } from 'src/app/features/questionnaires/features/table-grid/features/questionnaires-list-page/components/distribution-recipients/distribution-recipients.component';
import { QueDatePipe } from 'src/app/pipes/date.pipe';

@Component({
    selector: 'que-distribution-group-list-item',
    templateUrl: './distribution-group-list-item.component.html',
    styleUrls: ['./distribution-group-list-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, RecipientsReplyComponent, TranslateDirective, TranslatePipe, DistributionGroupMenuItemComponent, DistributionGroupSquareComponent, DistributionRecipientsComponent, QueDatePipe]
})
export class DistributionGroupListItemComponent implements OnInit {
  @Input() distributionGroup?: DistributionGroup;
  #dialog = inject(MatDialog);
  #distributionGroupStore = inject(DistributionGroupStore);
  userRecipients?:Recipients;

  ngOnInit(): void {
    this.userRecipients={groups:[],users:[...this.distributionGroup?.users?.map(u=> {return {user:u}as Recipient})??[]]}
  }
  groupClick() {
    if (this.distributionGroup?.isActive)
      this.editGroup();
  }
  editGroup() {
    this.#dialog.open(CreateDistributionGroupComponent,
      {
        data: { editGroup: this.distributionGroup },
        autoFocus: false,
        position: { top: '8%' },
        panelClass: 'dialog-panel'
      })
      .afterClosed().subscribe((result) => {
        if (result) {
          const [groupName, users, color, groupType] = result;
          const group = { ...this.distributionGroup, name: groupName, users, color, groupType } as DistributionGroup;
          if ((users)) {
            this.#distributionGroupStore.updateDistributionGroup(group);
          }
        }

      })
  }
}


